import {
    CloseOutlined,
} from '@ant-design/icons';
import { Box, Modal, Typography } from "@mui/material";
import register_modal from "../../assets/images/register_modal.jpeg";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#1E1E1E',
    color: '#fff',
    border: `1px solid #EBBC64`,
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.6)',
    borderRadius: '16px',
    p: 4,
    outline: 'none',
    maxWidth: '700px',
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    flexWrap: 'wrap',
    // backgroundImage: `url(${modalBackground2})`,
    backgroundSize: "cover",
    alignItems: "center"
};

const posterStyle = {
    // width: '250px',
    width: '250px',       // Take up the full width of the container
    height: '100%',      // Take up the full height of the container (or set a fixed height like '400px')
    borderRadius: '12px',
    objectFit: 'cover',
    border: '1px solid #EBBC64'
};

const ModalEvent = ({ open, handleClose }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                {/* Poster Image */}
                <img
                    src={register_modal}
                    alt="Event Poster"
                    style={posterStyle}
                />

                {/* Text Section */}
                <Box sx={{ flex: 1 }}>
                    <div className="d-flex justify-spaceBetween">
                        <Typography
                            className="creamText"
                            id="modal-modal-title"
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                        >
                            The Sound of Asia 2026-Finale
                        </Typography>
                        <CloseOutlined onClick={handleClose} />
                    </div>

                    <div style={{ height: '3px', backgroundColor: '#EBBC64', width: '60px', margin: '12px 0' }} />

                    <Typography className="creamText" variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Registration is now closed.
                    </Typography>
                    <Typography sx={{ color: '#ccc', mb: 2 }}>
                        Thank you to all musicians who submitted their applications.
                    </Typography>

                    <Typography className="creamText" variant="h6" sx={{ fontWeight: 600, mb: 0.5, mt: 2 }}>
                        Coming Up
                    </Typography>
                    <Typography sx={{ color: '#ccc', mb: 0.5 }}>
                        Winner Announcement: 3 October 2026
                    </Typography>
                    <Typography sx={{ color: '#ccc', mb: 2 }}>
                        Winner Performance: 14–15 November 2026
                    </Typography>

                    <Typography className="creamText" variant="h6" sx={{ fontWeight: 600, mb: 0.5, mt: 2 }}>
                        Tickets On Sale Now
                    </Typography>
                    <Typography sx={{ color: '#ccc', mb: 3 }}>
                        Be part of The Sound of Asia 2026 - Finale and experience the winner performances live in Jakarta.
                    </Typography>

                    <a
                        href="https://api.whatsapp.com/send/?phone=6282213002686"
                        style={{
                            backgroundColor: '#EBBC64',
                            color: '#1E1E1E',
                            padding: '10px 18px',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontWeight: 600,
                            display: 'inline-block'
                        }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        MORE INFO
                    </a>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalEvent;
